<template>
  <b-overlay :show="loading">
    <b-container fluid class="mb-6 mt-6 p-0">
      <b-row>
        <b-col>
          <div class="card card-custom gutter-b">
            <div class="mt-0">
              <v-data-table
                :headers="headers"
                :items="data"
                :item-class="rowClass"
                item-key="id"
                :items-per-page="-1"
                group-by="group"
                :group-desc="true"
                class="systems-parameter"
                hide-default-footer
              >
                <template v-slot:header.name="{ header, items }">
                  <v-icon @click.stop="expandAll"
                    >mdi-{{
                      isExpandedNew
                        ? 'unfold-more-horizontal'
                        : 'unfold-less-horizontal'
                    }}
                  </v-icon>
                  {{ header.text }}
                </template>

                <template
                  v-slot:group.header="{
                    toggle,
                    group,
                    isOpen,
                    headers,
                    items,
                  }"
                >
                  <td class="pl-0 no-background">
                    <div class="d-flex justify-content-between">
                      <div>
                        <v-btn
                          @click="toggle"
                          :ref="group"
                          :data-open="isOpen"
                          icon
                        >
                          <v-icon
                            >mdi-{{
                              isOpen ? 'chevron-down' : 'chevron-up'
                            }}</v-icon
                          >
                        </v-btn>

                        <span class="font-weight-boldest">
                          {{ items[0].title }}
                        </span>
                      </div>
                    </div>
                  </td>
                  <td></td>
                  <td>
                    <span class="summary">
                      {{ items[0].totalCalories }}
                      <span class="unit" style="font-weight: normal">kcal</span>
                    </span>
                  </td>
                  <td>
                    <span
                      class="font-weight-bold"
                      :class="items[0].isBalanced ? 'text-success' : 'text-warning'"
                    >
                      {{ items[0].score }}
                    </span>
                  </td>
                  <td>{{ items[0].note }}</td>
                  <td>
                    <div
                      v-if="items[0].aiAdvice"
                      class="ai-advice"
                      :class="{ 'ai-advice--open': expandedAdvice[group] }"
                      title="Bấm để xem đầy đủ / thu gọn"
                      @click.stop="$set(expandedAdvice, group, !expandedAdvice[group])"
                    >
                      {{ items[0].aiAdvice }}
                    </div>
                  </td>
                  <td>
                    <div class="d-flex">
                      <div
                        class="preview"
                        v-for="(url, index) in items[0].images"
                        :key="index"
                      >
                        <img
                          @click.stop="handlePreview(url)"
                          :src="url"
                          class="preview-image"
                          alt=""
                        />
                      </div>
                    </div>
                  </td>
                </template>
                <template v-slot:item="{ item }">
                  <tr v-if="item.name">
                    <td class="pt-2 pb-2">
                      <img
                        v-if="item.image"
                        class="rounded-sm thumb mr-2"
                        :src="item.image"
                        alt=""
                      />
                      {{ item.name }}
                    </td>
                    <td>
                      <div class="d-flex">
                        <span class="d-flex align-items-center">
                          {{ item.portion }}</span
                        >
                        <span class="unit pl-2"> {{ item.unit }}</span>
                      </div>
                    </td>
                    <td>
                      {{ item.calories }}
                      <span class="unit">kcal</span>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </template>
              </v-data-table>
            </div>
            <image-preview :image.sync="imagePreview" />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
export default {
  components: {
    'image-preview': () => import('../components/ModalPreview.vue'),
  },
  name: 'FoodTable',
  props: {
    time: {
      type: Object,
    },
    idUser: {
      type: [String, Number],
    },
    highlightId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isExpandedNew: true,
      isExpandedOld: true,
      headers: [
        { text: 'Ngày giờ nhập / Món ăn', value: 'name', sortable: false },
        { text: 'Khẩu phần', value: 'ration', sortable: false },
        { text: 'Số kcal', value: 'kcal', sortable: false },
        { text: 'Điểm bữa ăn', value: 'score', sortable: false },
        { text: 'Ghi chú', value: 'note', sortable: false },
        { text: 'Gợi ý AI', value: 'aiAdvice', sortable: false },
        {
          value: 'thumbnail',
          text: 'Hình ảnh',
          sortable: false,
        },
      ],
      data: [],
      paging: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      searchParams: {
        currentDateTime: parseInt(new Date().getTime() / 1000),
        page: 1,
        periodFilterType: 1,
        size: 1000,
      },
      imagePreview: null,
      expandedAdvice: {},
      loading: false,
    };
  },
  computed: {
    id() {
      return this.idUser;
    },
  },
  watch: {
    time: {
      handler(newVal) {
        this.searchParams.periodFilterType = newVal.value;
        this.loadData();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    rowClass(item) {
      return this.highlightId && item.recordId === this.highlightId ? 'highlight-row' : '';
    },
    // Đã tải hết dữ liệu trong kỳ; mỗi món 1 dòng, kèm thông tin bữa
    async exportRows() {
      return {
        columns: ['Ngày giờ, bữa', 'Món ăn', 'Khẩu phần', 'Đơn vị', 'Số kcal món', 'Tổng kcal bữa', 'Điểm bữa ăn', 'Ghi chú', 'Gợi ý AI', 'Hình ảnh bữa'],
        rows: this.data.map((e) => [
          e.title,
          e.name,
          e.portion,
          e.unit,
          e.calories,
          e.totalCalories,
          e.score,
          e.note,
          e.aiAdvice,
          e.images.join('\n'),
        ]),
      };
    },
    handlePreview(image) {
      this.imagePreview = image;
      this.$bvModal.show('image-preview');
    },

    loadData() {
      this.loading = true;
      this.$api
        .get(`Admin/Nutrition/Input`, {
          params: { ...this.searchParams, patientId: this.id },
        })
        .then(({ data }) => {
          this.data = (data || []).flatMap((e) => {
            const time = this.$moment(e.createDatetime * 1000);
            const meal = {
              // Key nhóm sort được theo thời gian, id để không gộp 2 bữa cùng phút
              group: `${time.format('YYYY-MM-DD HH:mm:ss')}|${e.id}`,
              recordId: e.id,
              title: `${time.format('HH:mm DD/MM/YYYY')}, ${e.timeFrameName}`,
              totalCalories: Math.round(e.totalCalories),
              score: e.totalMealScore,
              isBalanced: e.isBalanced,
              note: e.note,
              aiAdvice: e.aiAdvice,
              images: [
                ...(e.images || []).map((i) => i.url),
                e.imageUrl,
              ].filter(Boolean),
            };
            // Bữa không có món vẫn giữ 1 dòng để hiện nhóm
            if (!e.items?.length) return [{ ...meal, id: e.id }];
            return e.items.map((item) => ({
              ...meal,
              id: item.id,
              name: item.name,
              image: item.image?.url,
              portion: item.portion,
              unit: item.unitName,
              calories: Math.round(item.calories),
            }));
          });
          this.paging.total = data?.length || 0;
        })
        .catch((error) => {
          this.$toastr.e({
            title: 'Lỗi',
            msg: error,
          });
        })
        .finally(() => {
          this.loading = false;
        });
      return;
    },
    summaryNumber(items, key) {
      return items.reduce((acc, item) => acc + Number(item[key]), 0);
    },
    expandAll() {
      this.isExpandedNew = !this.isExpandedOld;
      // Filter vue-components
      Object.keys(this.$refs)
        .filter((e) => this.$refs[e]?.$el)
        .forEach((k) => {
          // Check if element has already open
          const status = this.$refs[k].$attrs['data-open'];
          if (status != this.isExpandedNew) {
            this.$refs[k].$el.click();
          }
          return;
        });
      this.isExpandedOld = this.isExpandedNew;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep tr.highlight-row > td {
  background-color: #fff3cd !important;
}
.unit {
  color: #b5b5c3;
}
.ai-advice {
  max-width: 360px;
  cursor: pointer;
  white-space: pre-line;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.ai-advice--open {
  display: block;
}
.summary {
  color: #21a567;
  font-weight: bold;
}
.thumb {
  width: 50px;
  height: 50px;
  object-fit: cover;
}
.preview {
  cursor: pointer;
  width: 40px;
  height: 40px;
}
.preview:not(:first-child) {
  margin-left: 10px;
}
.preview-image {
  border-radius: 6px;
  display: block;
  width: 100%;
  object-fit: cover;
  height: 100%;
}
</style>
